import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Embedder from '@/components/Embedder'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/vid/:videonr',
      name: 'HelloWorldSpecific',
      props: true,
      component: HelloWorld
    },
    {
      path: '/embed',
      name: 'Embedder',
      component: Embedder
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js